import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { UserStatus } from '../../enum';
import { ConfirmDialog } from '../common';
import { useChangeStatusAPI } from './selectors';
export var ChangeStatusDialog = function (_a) {
  var open = _a.open,
    user = _a.user,
    onClose = _a.onClose,
    onUserSaved = _a.onUserSaved;
  var t = useTranslation(['manageUser', 'translation']).t;
  var _b = useChangeStatusAPI(),
    changeStatusData = _b[0],
    changeStatus = _b[1],
    clearChangeStatusData = _b[2];
  useEffect(function () {
    if (open && changeStatusData.data) {
      onClose();
      onUserSaved === null || onUserSaved === void 0 ? void 0 : onUserSaved({
        created: false
      });
      return clearChangeStatusData;
    }
  }, [changeStatusData.data, onClose, onUserSaved, clearChangeStatusData, open]);
  var handleChangeStatus = function () {
    var payload = {
      id: user === null || user === void 0 ? void 0 : user.id,
      status: (user === null || user === void 0 ? void 0 : user.status) === UserStatus.Active ? UserStatus.Inactive : UserStatus.Active
    };
    changeStatus(payload);
  };
  return _jsx(ConfirmDialog, {
    open: open,
    onClose: onClose,
    title: t('changeStatusTitle', {
      username: user === null || user === void 0 ? void 0 : user.name
    }),
    message: t('translation:confirmation.yesChange'),
    onConfirm: handleChangeStatus,
    loading: !!changeStatusData.requesting,
    errors: [changeStatusData.error]
  });
};